import { render, staticRenderFns } from "./ColorsTable.vue?vue&type=template&id=726d3804&scoped=true&"
import script from "./ColorsTable.vue?vue&type=script&lang=ts&"
export * from "./ColorsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ColorsTable.vue?vue&type=style&index=0&id=726d3804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d3804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
